<div class="footer-section pb-5">
  <img src="../../assets/images/algo-logo-transparent.png" />
  <span class="copy-right">&#169; 2021 Algo Confidential</span>
</div>
